import React, { ReactNode } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { useAppContext } from '@/contexts/AppContext';
import SchemaOrg from '../common/SchemaOrg';
import GlobalBanner from '@/components/common/GlobalBanner';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { isDarkMode } = useAppContext();

  return (
    <div className={`min-h-screen flex flex-col ${isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'}`}>
      <SchemaOrg 
        type="Organization"
        name="splusd-solutions"
        description="Digitale Automatisierung für Ihr Business - Weniger manuelle Arbeit. Mehr Effizienz. Bessere Entscheidungen."
        address={{
          streetAddress: "Musterstraße 123",
          addressLocality: "Berlin",
          postalCode: "10115",
          addressCountry: "DE"
        }}
        sameAs={[
          "https://www.linkedin.com/company/splusd-solutions",
          "https://www.xing.com/companies/splusd-solutions"
        ]}
      />
      <Navbar />
      <main className="flex-grow pt-20">
        <GlobalBanner />
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout; 